module.exports = __webpack_public_path__ + "static/media/forest.9269f84e.jpg";